import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'

const Link = forwardRef ((props, ref) => (
  <MuiLink {...props} ref={ref} component={RouterLink} />
))

export default Link
